export const normalizePumpId = (pumpID) => {
  const normalized = String(pumpID ?? "").trim().toLowerCase();

  if (normalized === "pm" || normalized === "pressure maintenance" || normalized === "sustain") {
    return "pm";
  }

  return normalized;
};

export const isPressureMaintenancePump = (pumpID) => normalizePumpId(pumpID) === "pm";

export const getPumpDisplayLabel = (pumpID) => (
  isPressureMaintenancePump(pumpID) ? "PM" : (pumpID ?? "Unknown")
);
